const tpl = (name) => `DECLARATIONS/${name}`;

export const GET_DECLARATIONS = tpl`GET_DECLARATIONS`;
export const GET_DECLARATIONS_SUCCESS = tpl`GET_DECLARATIONS_SUCCESS`;
export const GET_DECLARATIONS_FAILURE = tpl`GET_DECLARATIONS_FAILURE`;

export const GET_HISTORY = tpl`GET_HISTORY`;
export const GET_HISTORY_SUCCESS = tpl`GET_HISTORY_SUCCESS`;
export const GET_HISTORY_FAILURE = tpl`GET_HISTORY_FAILURE`;
export const REMOVE_HISTORY_DECLARATION = tpl`REMOVE_HISTORY_DECLARATION`;

export const CLARIFY_DECLARATION = tpl`CLARIFY_DECLARATION`;
export const CLARIFY_DECLARATION_SUCCESS = tpl`CLARIFY_DECLARATION_SUCCESS`;
export const CLARIFY_DECLARATION_FAILURE = tpl`CLARIFY_DECLARATION_FAILURE`;

export const RESEND_DECLARATION = tpl`RESEND_DECLARATION`;
export const RESEND_DECLARATION_SUCCESS = tpl`RESEND_DECLARATION_SUCCESS`;
export const RESEND_DECLARATION_FAILURE = tpl`RESEND_DECLARATION_FAILURE`;

export const GET_DOCUMENTS = tpl`GET_DOCUMENTS`;
export const GET_DOCUMENTS_SUCCESS = tpl`GET_DOCUMENTS_SUCCESS`;
export const GET_DOCUMENTS_FAILURE = tpl`GET_DOCUMENTS_FAILURE`;

export const GET_PROPERTY_DEDUCTIONS_BALANCE = tpl`GET_PROPERTY_DEDUCTIONS_BALANCE`;
export const GET_PROPERTY_DEDUCTIONS_BALANCE_SUCCESS = tpl`GET_PROPERTY_DEDUCTIONS_BALANCE_SUCCESS`;
export const GET_PROPERTY_DEDUCTIONS_BALANCE_FAILURE = tpl`GET_PROPERTY_DEDUCTIONS_BALANCE_FAILURE`;
